import type { GetStaticPathsResult, GetStaticPropsContext } from "next/types";
import { withPage } from "src/utils/pagination/with-page";
import { ProductListingView } from "src/organisms/ProductListingView";
import { PRODUCT_LIST_TYPE } from "src/utils/constants";
import type {
  CategoryProductList,
  ProductListProps,
} from "src/types/product-listing";
import { useLingui } from "@lingui/react";
import { msg } from "@lingui/macro";
import {
  getProductListProps,
  type ProductListReturnType,
} from "src/utils/search-provider/get-product-list-props";

type NewInPageProps = ProductListProps<CategoryProductList>;

export default function NewInPage({
  pageProps: props,
}: {
  pageProps: NewInPageProps;
}): JSX.Element {
  const { i18n } = useLingui();

  return (
    <ProductListingView
      defaultSorting="NEW"
      title={i18n._(msg`New items`)}
      {...props}
    />
  );
}

export function getStaticPaths(): GetStaticPathsResult {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export const getStaticProps = withPage(async function getStaticProps(
  { params }: GetStaticPropsContext<{ slug: string }>,
  page
): ProductListReturnType {
  return getProductListProps({
    type: PRODUCT_LIST_TYPE.NEW_IN_PLP,
    defaultBreadcrumbs: [{ title: "Home", slug: "/" }, { title: "New In" }],
    gender: params?.slug,
    page,
  });
});
